import React from "react";
import "./HomePage.css";
import { Link } from "react-router-dom";
//import Logo from "../assets/qa_logo.png";

function HomePage() {
  return (
    <div className="homepage">
      {/* HERO SECTION */}
      <section className="hero">
        <h1>AI-Powered Tools for QA Engineers</h1>
       
        <p>
          Automate test cases, analyze bugs, generate scripts, and accelerate QA workflows
          using intelligent AI tools built for modern testing teams.
        </p>

        <div className="hero-buttons">
          <Link to="/tools" className="btn-primary">Try AI Tools</Link>
          <Link to="/qa-chatbot" className="btn-secondary">Chat With AI</Link>
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section className="features">
        <h2>What You Can Do</h2>

        <div className="feature-grid">

          <Link to="/testcases" className="feature-card">
            <h3>🧪 AI Test Case Generator</h3>
            <p>Generate structured, step-by-step test cases instantly.</p>
          </Link>

         <Link to="/qa-tutorials" className="feature-card">
          <h3>📘 QA Tutorials</h3>
         <p>Real automation frameworks using MSTest & POM.</p>
          </Link> 

          <Link to="/script-writer" className="feature-card">
            <h3>💻 Automation Script Writer</h3>
            <p>Generate Selenium / Playwright code using POM structure.</p>
          </Link>

          <Link to="/qa-chatbot" className="feature-card">
            <h3>🤖 QA Chatbot</h3>
            <p>Get answers for testing, SQL, API, automation & more.</p>
          </Link>

        </div>
      </section>

    </div>
  );
}

export default HomePage;
